import React from 'react';  
import { Modal, List, Typography, Button, Space } from 'antd';  
const { Text } = Typography;  
  
const TeacherModal = ({ visible, onClose, group }) => {  
    if (!group) return null; // handle null case  
  
    return (  
        <Modal  
            title="Coach Info"  
            open={visible}  
            onCancel={onClose}  
            footer={[  
                <Button key="close" onClick={onClose}>  
                    Close  
                </Button>  
            ]}  
        >  
            <Space direction="vertical" size="small" style={{ marginBottom: 16 }}>  
                <Text strong>Coach Name: </Text>  
                <Text>{group.teacher_name || <em>None</em>}</Text>  
                <Text strong>Coach Number: </Text>  
                <Text>{group.teacher_number || <em>None</em>}</Text>  
                <Text strong>Coach Email: </Text>  
                <Text>{group.teacher_email || <em>None</em>}</Text>  
            </Space>  
        </Modal>  
    );  
};  
  
export default TeacherModal;